import styled from 'styled-components';

export const DashStyle = styled.div`
#list_users_status {
  height: calc(100% - 25vh);
}
`;